import { path } from 'ramda';
import { createSelector } from 'reselect';

import { getCommissionSplitShops, getDailyPayrollShops } from '../shops/reducers';

export const getEndOfPayoutById = path(['admin', 'payouts', 'endOfPayoutById']);
export const getTotalById = path(['admin', 'payouts', 'totalById']);
export const getDailyPayrollById = path(['admin', 'payouts', 'dailyPayrollById']);
export const getLastPayoutDateById = path(['admin', 'payouts', 'lastPayoutDateId']);

const mapShops = (shops, endOfPayout, total, lastPayoutDate) => (
  shops.map(shop => ({
    id: shop.id,
    name: shop.name,
    endOfPayout: endOfPayout[shop.id],
    total: total[shop.id],
    lastPayout: lastPayoutDate[shop.id],
    timezone: shop.timezone,
    commissionSplitsAutoDeposit: shop.commissionSplitsAutoDeposit,
    userId: path(['users', '0', 'id'], shop),
  }))
);

export const getReport = createSelector(
  getCommissionSplitShops,
  getEndOfPayoutById,
  getTotalById,
  getLastPayoutDateById,
  mapShops
);

const mapShopsForTipsPayroll = (shops, total) => (
  shops.map(shop => ({
    id: shop.id,
    name: shop.name,
    lastTransferAmount: path([shop.id, 'lastTransferAmount'], total),
    lastTransferDate: path([shop.id, 'lastTransferDate'], total),
    accumulatedBalance: path([shop.id, 'accumulatedBalance'], total),
    timezone: shop.timezone,
    userId: path(['users', '0', 'id'], shop),
    dailyPayrollTipFee: shop.dailyPayrollTipFee,
  }))
);

export const getTipsReport = createSelector(
  getDailyPayrollShops,
  getDailyPayrollById,
  mapShopsForTipsPayroll,
);
